import Vue from 'vue'

Vue.directive('selected', (el, binding) => {
  if (binding.value) {
    el.classList.add('item-selected')
  } else {
    el.classList.remove('item-selected')
  }
})
